module.exports = __webpack_public_path__ + "static/media/Floor2_Before.617d0688.jpg";